import TransferAccountsTab from './TransferAccountsTab';

export default TransferAccountsTab;
